import config from 'config';
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { SINGLE_NAVIGATION_PATHS } from '../../constants/single-navigation-paths';

const getRedirectUrlByErrorStatus = (status: number): string => {
    const realm = localStorage.getItem('realm');
    let redirectUrl = window.location.origin;

    switch (status) {
        case 404:
            redirectUrl = `${redirectUrl}/${SINGLE_NAVIGATION_PATHS.NOT_FOUND_ERROR}`;
            break;
        case 403:
            redirectUrl = `${redirectUrl}/${SINGLE_NAVIGATION_PATHS.INSUFFICIENT_PERMISSION_ERROR}`;
            break;
        default:
            redirectUrl = realm
                ? `${redirectUrl}/?realm=${realm}`
                : redirectUrl;
    }

    return redirectUrl;
};

const instance = (history = null): AxiosInstance => {
    const axiosInstance = axios.create({ baseURL: config.apiBaseUrl });

    axiosInstance.interceptors.response.use(
        (response) => Promise.resolve(response),
        (error) => {
            if (!error.response) {
                return Promise.reject(new Error(error));
            }

            if (
                error.response.status === 404 ||
                error.response.status === 403 ||
                error.response.status === 401
            ) {
                const redirectUrl = getRedirectUrlByErrorStatus(
                    error.response.status
                );

                if (history) {
                    (window as any).history.push(redirectUrl);
                } else {
                    (window as any).location = redirectUrl;
                }
                return Promise.reject(
                    error.response as AxiosError<AxiosResponse>
                );
            } else {
                return Promise.reject(
                    error.response as AxiosError<AxiosResponse>
                );
            }
        }
    );

    return axiosInstance;
};

const withHeaders = (headers?: any): { headers: any } => {
    return { headers: headers };
};

const isStatusCodeSuccessful = (status: number): boolean => {
    return status >= 200 && status < 300;
};

export { instance, withHeaders, isStatusCodeSuccessful };
